/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';
import {
  UpdateUserActions,
  UpdateUserActionTypes,
  updateUserFailed,
  UpdateUserRequest,
  updateUserSucceeded,
} from './action';
import { setAuthenticatedClient } from '../../../../client/graphql';
import { updateUserQuery } from './updateUserQuery';

/* Local dependencies */

export function updateUserEpic(action$): Observable<UpdateUserActions> {
  return action$.pipe(
    filter((action: UpdateUserActions) => action.type === UpdateUserActionTypes.UPDATE_USER_REQUEST),
    switchMap((action: UpdateUserRequest) =>
      getUser(action.input)
        .then(updateUserSucceeded)
        .catch((error) => updateUserFailed(error.message)),
    ),
  );
}

export async function getUser(input) {
  console.log('📦 UpdateUser: Начинаем обновление данные пользователя');

  const graphQLClient = await setAuthenticatedClient();
  console.log('📦 GraphQL Client:', graphQLClient ? 'OK' : 'NULL');
  try {
    const {
      data: { updateUser: user },
    } = await graphQLClient.mutate({
      mutation: updateUserQuery,
      variables: { input },
    });
    console.log('📦  UpdateUserRequest:', JSON.stringify(user, null, 2));

    return user;
  } catch (e) {
    if (e) console.error('❌ Полная ошибка:', e);
    console.error('❌ GraphQL errors:', JSON.stringify(e.graphQLErrors, null, 2));

    // Выводим каждую ошибку отдельно
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
      e.graphQLErrors.forEach((err, index) => {
        console.error(`❌ Ошибка ${index + 1}:`, err.message);
        console.error(`   Path:`, err.path);
        console.error(`   Extensions:`, err.extensions);
      });
    }

    throw new Error('Failed to update user data');
  }
}
